export type ImportElementType =
  | 'OBJECT_LIBRARY'
  | 'DATA_SHEET'
  | 'TEST_MODULE'
  | 'TEST_CASE'
  | 'TEST_PLAN'
  | 'REQUIREMENT'
  | 'DOCUMENT';
export type ProjectImportStatus = 'ANALYZED' | 'COMMITTED' | 'FAILED';
export type ImportMessageLevel = 'ERROR' | 'WARNING' | 'INFO';
export type ImportMessageGroup = 'BLOCKING' | 'REBUILT' | 'NOT_EXECUTABLE' | 'LOST' | 'NOTE';
export type ImportQuestionType = 'USER_MAPPING' | 'ENCRYPT_PLAINTEXT' | 'EXISTING_ELEMENT';

export interface ImportOrigin {
  tool: string | null;
  version: string | null;
  file: string | null;
  line: number | null;
}

export interface ImportCount {
  created: number;
  replaced: number;
  unchanged: number;
  skipped: number;
}

export interface ImportReportMessage {
  level: ImportMessageLevel;
  code: string;
  group: ImportMessageGroup;
  element: string | null;
  name: string | null;
  step: number | null;
  origin: ImportOrigin | null;
  text: string;
}

export interface ImportQuestion {
  id: string;
  type: ImportQuestionType;
  element: string;
  text: string;
  options: string[];
  defaultAnswer: string | null;
}

export interface ImportSummary {
  repository: string | null;
  steps: number;
  stepsClean: number;
  stepsWithFindings: number;
  stepsNotExecutable: number;
  stepsRebuilt: number;
  percentClean: number;
  percentNotExecutable: number;
  percentRebuilt: number;
}

export interface ImportReport {
  blockers: ImportReportMessage[];
  counts: Partial<Record<ImportElementType, ImportCount>>;
  messages: ImportReportMessage[];
  questions: ImportQuestion[];
  summaries: ImportSummary[];
  failure: string | null;
  blocked: boolean;
}

export interface ImportTreeNode {
  sourceKey: string;
  type: ImportElementType;
  name: string;
  folder: string[];
  dependsOn: string[];
}

export interface ProjectImport {
  id: string;
  status: ProjectImportStatus;
  sourceTool: string;
  fileName: string;
  tree: ImportTreeNode[];
  selection: string[] | null;
  answers: Record<string, string> | null;
  report: ImportReport;
  createdAt: string;
  committedAt: string | null;
}

export interface UpdateProjectImportRequest {
  selection: string[] | null;
  answers: Record<string, string> | null;
}

/** Antworten auf ENCRYPT_PLAINTEXT. */
export const ENCRYPT = 'ENCRYPT';
export const KEEP = 'KEEP';
/** Antworten auf EXISTING_ELEMENT. */
export const REPLACE = 'REPLACE';
export const SKIP = 'SKIP';

/** Wie `ProjectImportService.MAX_FILE_BYTES` im BE. */
export const MAX_IMPORT_FILE_BYTES = 50 * 1024 * 1024;
